angular.module('blc').factory('currency_srv', currency_srv);
currency_srv.$inject = ['browser'];
function currency_srv(browser) {
  var rates = {'EUR': 1, USD: 1},
      glyphs = { EUR: '€',USD: '$', GBP: '£', CHF: 'CHF' }
      current_code = 'EUR';

  browser.getData.then(function(data) {
    rates = data.data.rates;
  });
  return {
    set_currency: function(code) { 
      current_code = code; 
    },
    get_currency: function() { 
      return { code: current_code, rate: rates[current_code],sym: glyphs[current_code]}  
    },
  }
}


angular.module('blc').filter('currency', ['currency_srv', function(currency_srv) {
  return function(input) {
    var curr = currency_srv.get_currency();
    return "<sup>" + curr.sym + "</sup>" + input * curr.rate ;
  }
}])



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/currency-service.js
 ** module id = 19
 ** module chunks = 0
 **/